import { ListLoadingPlaceholderListItems } from 'modules/list/listPage/ListLoadingPlaceholder/ListLoadingPlaceholderListItems';
import { BgColor } from '../../../components/Color';
import { MovingGradient } from '../../../components/MovingGradient';
import PaddingBox from '../../../components/PaddingBox';
import { SearchTextbox } from '../../../components/SearchTextbox';
import TooltipBtn from '../../../components/TooltipBtn';
import { isMobile, isMobileAny } from '../../../utils/device';
import { ListFilterListSearchPortal } from '../../list/components/ListFilterListSearch/ListFilterListSearchPortal';
import { ListLayout } from '../../list/components/ListLayout';
import { ListSidebarIndicatorButton } from '../../list/components/ListSidebar/ListSidebarIndicatorButton';
import { ListLoadingPlaceholderBar } from '../../list/listPage/ListLoadingPlaceholder/ListLoadingPlaceholderBar';
import { ListLoadingPlaceholderSidebar } from '../../list/listPage/ListLoadingPlaceholder/ListLoadingPlaceholderSidebar';
import periodNavigatorClasses from 'modules/timecard/list/components/TimecardListPeriodNavigator/styles/index.module.scss';

function TimecardListLoadingPlaceholder() {
	return (
		<ListLayout>
			<ListLoadingPlaceholderBar titleCode={705} />
			<PaddingBox bottomSmall>
				<BgColor
					color='white'
					className={periodNavigatorClasses.clockwiseListPeriodNavigator}
				>
					<PaddingBox
						vrTiny
						hrSmall={!isMobile}
						hrScanty={isMobile}
					>
						<TooltipBtn
							tooltip={<h1></h1>}
							style={{
								position: 'relative',
							}}
							scantyPadding={isMobile}
							disabled
							delayedDisable
							styledButton
							widthContent
							link
							bold
							size='small'
						>
							<MovingGradient
								height='17px'
								width='170px'
							/>
						</TooltipBtn>
					</PaddingBox>
				</BgColor>
			</PaddingBox>
			<ListLoadingPlaceholderListItems
				columnsCount={9}
				hasMultiselect
				hasColumnSwitcher
			/>
			<ListSidebarIndicatorButton disabled />
			<ListFilterListSearchPortal searchButtonDisabled>
				<SearchTextbox
					size='small'
					className='filterListSearchTextbox'
					disabled
				/>
			</ListFilterListSearchPortal>
			{!isMobileAny && <ListLoadingPlaceholderSidebar />}
		</ListLayout>
	);
}

export { TimecardListLoadingPlaceholder };
